import { render } from "./CreateExternalReferralRow.vue?vue&type=template&id=0be441d2&ts=true"
import script from "./CreateExternalReferralRow.ts?vue&type=script&lang=ts&external"
export * from "./CreateExternalReferralRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__